.widgetPanel {
  background-color: var(--vkui--color_background_modal);
  box-shadow: var(--vkui--elevation3);
  display: none;
  width: 420px;
  max-height: 724px;
  height: calc(100% - 32px - var(--vks-support-widget-panel-offset-top, 0px));
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 10000;
  border-radius: 12px;
  overflow: hidden;
  will-change: transform;

  &.isMobile {
    width: 100%;
    height: calc(
      100% - var(--vks-support-widget-panel-offset-top, 0px) - var(--vkui_internal--safe_area_inset_top) -
        var(--vkui_internal--safe_area_inset_bottom)
    );
    max-height: 100%;
    right: 0;
    bottom: var(--vkui_internal--safe_area_inset_bottom);
  }

  &.isWidgetOpen {
    display: block;
  }
}

.widgetPanelContent {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
